import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'
import { EN_US_LOCALE, LOCALE_STORAGE_KEY, normalizeLocale, ZH_CN_LOCALE } from '@/utils/locale'

const savedLocale = normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY))

document.documentElement.lang = savedLocale

const i18n = createI18n({
  legacy: false, // 启用 Composition API 模式
  locale: savedLocale, // 使用保存的语言
  fallbackLocale: EN_US_LOCALE,
  messages: {
    [ZH_CN_LOCALE]: zhCN,
    [EN_US_LOCALE]: enUS,
  },
})

export default i18n
